import apiClient from './api';

// Consulta el endpoint agregador /calendar/data: transacciones reales +
// ocurrencias proyectadas de series recurrentes + alertas de vencimiento
// de deuda + saldo diario/proyectado, todo en un solo rango de fechas.
const calendarService = {
  // selector: { accountIds } o { debtId } (mutuamente excluyentes, el
  // backend rechaza si se mandan ambos). Ninguno de los dos = todas las
  // cuentas combinadas.
  //
  // 1 sep 2026 (Augusto: "el calendario me está colocando una mezcla de
  // dólares y soles... necesito la opción de toggle... utilizando el
  // tipo de cambio del día"): `vista` es 'soles' o 'dolares' -- el
  // backend convierte TODO (ingresos, gastos, saldos, alertas de deuda)
  // a esa única moneda con el tipo de cambio del BCRP, y lo devuelve en
  // tipo_cambio (ver CalendarPage.js). Por defecto 'soles', igual que el
  // backend.
  // 4 sep 2026 (Augusto: cuentas de reserva/ahorro intocables no deben
  // "confundir" el calendario): incluirReservas=true pide que se incluyan
  // en el agregado "todas las cuentas" -- no tiene efecto si se pasa
  // accountIds (una cuenta pedida a propósito siempre se muestra, sea o
  // no reserva -- ver app/api/v1/endpoints/calendar.py).
  // 21 sep 2026 (Augusto: "en calendario, se necesita la opción de
  // seleccionar 1 o más cuentas"): accountIds es una lista. La query se
  // arma a mano porque axios serializa un array como
  // `account_ids[]=1&account_ids[]=2` y FastAPI espera el mismo nombre
  // repetido sin corchetes.
  getData: async (start, end, { accountIds, debtId, vista, incluirReservas } = {}) => {
    const qs = new URLSearchParams();
    qs.append('start', start);
    qs.append('end', end);
    qs.append('vista', vista || 'soles');
    (accountIds || []).forEach((id) => qs.append('account_ids', id));
    if (debtId) qs.append('debt_id', debtId);
    if (incluirReservas) qs.append('incluir_reservas', 'true');
    return apiClient.get(`/calendar/data?${qs.toString()}`);
  },
};

export default calendarService;
